module.exports = __webpack_public_path__ + "static/sharetrace-covid-19-screenshots-c72c5d5e9d911ab2f2a037c1dc5cbd08.png";